import { Button, Grid, Typography, useTheme } from "@mui/material";
import React, { createContext, useState } from "react";

import AlertModal from "components/AlertModal";

const initialAlertProps = {
  variant: "success",
  onClose: () => {},
  text: "",
  button: "بازگشت",
};

export const AlertModalContext = createContext(initialAlertProps);

function AlertModalContextProvider({ children }) {
  const theme = useTheme();
  const [alertProps, setAlertProps] = useState(initialAlertProps);
  const [showAlertModal, setShowAlertModal] = useState(false);

  const handleClose = () => {
    setShowAlertModal(false);
  };

  return (
    <AlertModalContext.Provider value={{ setShowAlertModal, setAlertProps }}>
      {children}

      <AlertModal
        open={showAlertModal}
        onClose={handleClose}
        variant={alertProps?.variant}
        color={theme.palette.success.main}
        allowClickAway={false}
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography
              textAlign="center"
              dir="rtl"
              variant="h5"
              color="text.main"
            >
              {alertProps?.text}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Button
              fullWidth
              color={alertProps?.variant}
              onClick={() => {
                handleClose();
                if (alertProps?.onClose) {
                  alertProps?.onClose();
                }
              }}
            >
              {alertProps?.button || "بازگشت"}
            </Button>
          </Grid>
        </Grid>
      </AlertModal>
    </AlertModalContext.Provider>
  );
}

export default AlertModalContextProvider;
